module.exports = __webpack_public_path__ + "static/media/10.fdd28960.png";